import styled from 'styled-components';
import List from 'antd/lib/list';
import { createGlobalStyle } from 'styled-components';

export const DatasetItemDropdownStyle = createGlobalStyle`
  .map-dataset-actions-dropdown {
    min-width: 168px;
  }

  .map-dataset-actions-dropdown .ant-menu {
    min-width: 156px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
    padding: 4px 0;
  }

  .map-dataset-actions-dropdown .ant-menu-item {
    min-width: 156px;
    height: auto;
    line-height: 1.2;
    margin: 0;
    padding: 0;
  }

  .map-dataset-actions-dropdown .ant-menu-item > a {
    display: block;
    padding: 12px 16px;
  }
`;

export const ListItem = styled(List.Item)`
  justify-content: space-between;
  padding-left: 16px !important;
  padding-right: 10px !important;

  .ant-list-item-action {
    margin-left: 16px;
  }

  .ant-list-item-action > li {
    padding-left: 0;
  }
`;

export const LocationContainer = styled.div`
 display: flex;
 width: max-content;
 align-items: center;
 margin-top: 5px;
 height: 30px;

 & > div {
  position: absolute;
  background-color: #f8f9fa;
  padding: 0 5px;
 }
`;

export const DropdownTrigger = styled.span`
  display: inline-flex;
  align-items: center;

  .ant-btn:hover,
  .ant-btn:focus {
    color: #165391;
    border-color: #91b7e3;
    background: #f5f7fa;
  }
`;

export const ActionLink = styled.a`
  color: #165391;

  &:hover {
    color: #2f80ed;
  }
`;

export const RemoveActionLink = styled(ActionLink)`
  color: #ff4d4f;

  &:hover {
    color: #ff7875;
  }
`;
